import React, { useState, useEffect } from 'react'
import { useParams, useNavigate } from 'react-router-dom'
import driverService from '../../api/services/driverService'
import PhoneInput from 'react-phone-input-2'
import 'react-phone-input-2/lib/bootstrap.css'
import countryList from 'react-select-country-list';
import { toast } from 'react-toastify';
import useMapLocation from '../../hooks/useMapLocation';
import { Autocomplete, GoogleMap } from '@react-google-maps/api';
import SafeImage from '../../components/common/SafeImage';
import { getCurrencySymbolFromPhone } from "../../utils/currencyFromPhone"; 
const AddorUpdate = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const [driverInfo, setDriverInfo] = useState({
        firstName: '',
        email: '',
        phoneNumber: '',
        vechileType: '',
        vechileNumber: '',
        profile_image: '',
        address_line1: '', // for location

        // 🔹 Commission fields
   // 🔹 Commission fields (3-column model)
commissionType: '',   // fixed | kmperamount | percentage
commission: '',       // fixed amount / per KM / percentage
basePrice: '',        // only for kmperamount


    });
    const [loading, setLoading] = useState(false);
    const [fetchingDriver, setFetchingDriver] = useState(false);
    const [profileImage, setProfileImage] = useState(null);
    const [profileImagePreview, setProfileImagePreview] = useState('');
    const [countries] = useState(countryList().getData());
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const [formData, setFormData] = useState({ longitude: '', latitude: '' });
    const [showLocationModal, setShowLocationModal] = useState(false);
    const [isLocationLoaded, setIsLocationLoaded] = useState(false);
    const [locationLoading, setLocationLoading] = useState(false);
    const containerStyle = { width: '100%', height: '300px' };
    const centerDefault = { lat: 20.5937, lng: 78.9629 };
    const [mapCenter, setMapCenter] = useState(centerDefault);
    const [currencySymbol, setCurrencySymbol] = useState(" ");

    const mapRef = React.useRef(null);
    const {
      isLoaded,
      country,
      latLng,
      address: mapAddress,
      setAddress,
      setLatLng,
      onPlaceChanged,
      error: mapError,
      autocompleteRef,
      geocodeAddress
    } = useMapLocation();

    useEffect(() => {
        if (id && id !== 'null' && id !== 'undefined') {
            fetchDriverData();
        }
    }, [id]);

    // Set preview if driver has an image
    useEffect(() => {
        if (id && driverInfo.profile_image && typeof driverInfo.profile_image === 'string' && driverInfo.profile_image.trim() !== '') {
            setProfileImagePreview(
                driverInfo.profile_image.startsWith('http')
                    ? driverInfo.profile_image
                    : import.meta.env.VITE_API_URL ? `${import.meta.env.VITE_API_URL}${driverInfo.profile_image}` : `http://localhost:8000${driverInfo.profile_image}`
            );
        }
    }, [id, driverInfo.profile_image]);

    // Add effect to update map center when latLng changes
    useEffect(() => {
      if (latLng) {
        setMapCenter(latLng);
      }
    }, [latLng]);
useEffect(() => {
  // DB-la irundhu vandha address irundha, map hook-ku initial-aa set pannalam
  if (driverInfo.address_line1 && !mapAddress) {
    setAddress(driverInfo.address_line1);
  }
}, [driverInfo.address_line1]);

useEffect(() => {
  const sym = getCurrencySymbolFromPhone(driverInfo.phoneNumber);
  setCurrencySymbol(sym || " ");
}, [driverInfo.phoneNumber]);


    const fetchDriverData = async () => {
        if (!id || id === 'null' || id === 'undefined') {
            console.warn('Invalid driver ID:', id);
            return;
        }

        try {
            setFetchingDriver(true);
            const result = await driverService.getDriverById(id);
            
            if (result.success) {
                const driver = result.data;
                
                const newDriverInfo = {
                    firstName: driver.user?.name || '',
                    email: driver.user?.email || '',
                    phoneNumber: driver.user?.phone_no || '',
                    vechileType: driver.vehicle_type || '',
                    vechileNumber: driver.vehicle_no || '',
                    profile_image: driver.user?.profile_image || '',
                    address_line1: driver.address?.address_line1 || driver.location || '', // ensure address_line1 is set

                    // 🔹 Commission from backend (adjust names if needed)
  // 🔹 Commission from backend (3-column)
commissionType: driver.commission_type || '',
commission:
  driver.commission !== null && driver.commission !== undefined
    ? String(driver.commission)
    : '',
basePrice:
  driver.base_price !== null && driver.base_price !== undefined
    ? String(driver.base_price)
    : '',



                };
                
                setDriverInfo(newDriverInfo);

                // Pre-fill map and formData with latitude and longitude from database (allow zero values)
                if ((driver.latitude || driver.latitude === 0) && (driver.longitude || driver.longitude === 0)) {
                    setFormData({
                        latitude: driver.latitude.toString(),
                        longitude: driver.longitude.toString()
                    });
                    setMapCenter({
                        lat: parseFloat(driver.latitude),
                        lng: parseFloat(driver.longitude)
                    });
                    setLatLng({
                        lat: parseFloat(driver.latitude),
                        lng: parseFloat(driver.longitude)
                    });
                }
            } else {
                toast.error(result.message || 'Failed to fetch driver data');
            }
        } catch (error) {
            console.error('Error fetching driver:', error);
            toast.error('Failed to fetch driver data');
        } finally {
            setFetchingDriver(false);
        }
    };

    const handleInfoChange = (e) => {
        const { name, value } = e.target;
        setDriverInfo(prevInfo => ({
            ...prevInfo,
            [name]: value,
        }));
    };

   const handlePhoneChange = (value) => {
  // react-phone-input-2 gives digits only, so we add +
  const phoneWithPlus = value ? `+${value}` : '';
  setDriverInfo(prev => ({ ...prev, phoneNumber: phoneWithPlus }));
};


    const handleProfileImageChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            setProfileImage(file);
            setProfileImagePreview(URL.createObjectURL(file));
            setDriverInfo(prev => ({ ...prev, profile_image: file }));
        }
    };

    const handleLocationSelect = () => {
      if (mapCenter) {
        setFormData((prev) => ({
          ...prev,
          longitude: mapCenter.lng.toString(),
          latitude: mapCenter.lat.toString()
        }));
        // Reverse geocode to update address fields
        if (window.google && window.google.maps) {
          const geocoder = new window.google.maps.Geocoder();
          geocoder.geocode({ location: mapCenter }, (results, status) => {
            if (status === "OK" && results[0]) {
              setAddress(results[0].formatted_address);
              // Parse address components for city, state, postal_code, country
              const addressComponents = results[0].address_components || [];
              const getComponent = (type) => {
                const comp = addressComponents.find(c => c.types.includes(type));
                return comp ? comp.long_name : '';
              };
              setDriverInfo((prev) => ({
                ...prev,
                address_line1: results[0].formatted_address,
                city: getComponent('locality') || getComponent('administrative_area_level_2'),
                state: getComponent('administrative_area_level_1'),
                postal_code: getComponent('postal_code'),
                country: getComponent('country'),
              }));
            }
          });
        }
        setShowLocationModal(false);
        setIsLocationLoaded(true);
        if (errors.location) {
          setErrors(prev => ({ ...prev, location: '' }));
        }
      }
    };
    const handleOpenLocationModal = () => {
      setShowLocationModal(true);
      setTouched(prev => ({ ...prev, location: true }));
      if (!latLng) {
        setLatLng(centerDefault);
      }
    };
    const handleGetCurrentLocation = () => {
      setLocationLoading(true);
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const { latitude, longitude } = position.coords;
            setLatLng({ lat: latitude, lng: longitude });
            // Reverse geocode to get address
            if (window.google && window.google.maps) {
              const geocoder = new window.google.maps.Geocoder();
              geocoder.geocode({ location: { lat: latitude, lng: longitude } }, (results, status) => {
                if (status === "OK" && results[0]) {
                  setAddress(results[0].formatted_address);
                }
                setLocationLoading(false);
              });
            } else {
              setLocationLoading(false);
            }
          },
          (error) => {
            toast.error("Unable to fetch your location. Please allow location access.");
            setLocationLoading(false);
          }
        );
      } else {
        toast.error("Geolocation is not supported by your browser.");
        setLocationLoading(false);
      }
    };

    // Validation function
    const validateForm = () => {
        const newErrors = {};
        // Name
        if (!driverInfo.firstName) {
            newErrors.firstName = 'Name is required';
        }
        // Email
        if (!driverInfo.email) {
            newErrors.email = 'Email is required';
        } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(driverInfo.email)) {
            newErrors.email = 'Please enter a valid email address';
        }
        // Phone
        if (!driverInfo.phoneNumber) {
            newErrors.phoneNumber = 'Phone number is required';
        } else if (!/^\+?[1-9]\d{7,14}$/.test(driverInfo.phoneNumber)) {
            newErrors.phoneNumber = 'Please enter a valid international phone number (e.g., +1234567890)';
        }
        // Vehicle Type
        if (!driverInfo.vechileType) {
            newErrors.vechileType = 'Vehicle type is required';
        }
        // Vehicle Number
        if (!driverInfo.vechileNumber) {
            newErrors.vechileNumber = 'Vehicle number is required';
        }
        // Profile Image
        if (!id && !profileImage) {
            newErrors.profile_image = 'Profile image is required';
        }
        // Business Location
        if (!formData.longitude || !formData.latitude) {
            newErrors.location = 'Business location is required';
        }
       // 🔹 Commission validation
// 🔹 Commission validation (3-column)
if (!driverInfo.commissionType) {
  newErrors.commissionType = 'Commission type is required';
} else {
  const type = driverInfo.commissionType;
  const commissionVal = driverInfo.commission;
  const basePriceVal = driverInfo.basePrice;

  if (type === 'fixed') {
    if (!commissionVal) {
      newErrors.commission = 'Fixed amount is required';
    } else if (isNaN(commissionVal) || Number(commissionVal) <= 0) {
      newErrors.commission = 'Enter a valid amount';
    }
  } else if (type === 'kmperamount') {
    if (!commissionVal) {
      newErrors.commission = 'Amount per KM is required';
    } else if (isNaN(commissionVal) || Number(commissionVal) <= 0) {
      newErrors.commission = 'Enter a valid amount per KM';
    }

    if (!basePriceVal) {
      newErrors.basePrice = 'Base price is required';
    } else if (isNaN(basePriceVal) || Number(basePriceVal) < 0) {
      newErrors.basePrice = 'Enter valid base price';
    }
  } else if (type === 'percentage') {
    if (!commissionVal) {
      newErrors.commission = 'Commission percentage is required';
    } else if (
      isNaN(commissionVal) ||
      Number(commissionVal) <= 0 ||
      Number(commissionVal) > 100
    ) {
      newErrors.commission = 'Enter a valid percentage between 1 and 100';
    }
  }
}

return newErrors;
    };

    // Live validation: validate on every change
    useEffect(() => {
        setErrors(validateForm());
        // eslint-disable-next-line
    }, [driverInfo]);
// 🟢 BEFORE const payload = { ... } inside handleSubmit


    const handleSubmit = async (e) => {
      
        e.preventDefault();
        // Mark all fields as touched to show errors
        setTouched({
            firstName: true,
            email: true,
            phoneNumber: true,
            vechileType: true,
            vechileNumber: true,
            location: true,
            profile_image: true,
        });

        // Validate required fields
        if (Object.values(validateForm()).length > 0) {
            return;
        }

        try {
            setLoading(true);
            // 🟢 1. Commission values normalize (string → number or null)
    // 🔹 Commission normalize (3-column)
const commissionType = driverInfo.commissionType;

let commission = null;
let basePrice = null;

if (commissionType === 'fixed') {
  commission =
    driverInfo.commission !== '' ? parseFloat(driverInfo.commission) : null;
  basePrice = null;
} else if (commissionType === 'kmperamount') {
  commission =
    driverInfo.commission !== '' ? parseFloat(driverInfo.commission) : null;
  basePrice =
    driverInfo.basePrice !== '' ? parseFloat(driverInfo.basePrice) : null;
} else if (commissionType === 'percentage') {
  commission =
    driverInfo.commission !== '' ? parseFloat(driverInfo.commission) : null;
  basePrice = null;
}

            const payload = {
                name: driverInfo.firstName,
                email: driverInfo.email,
                phone_no: driverInfo.phoneNumber,
                vehicle_type: driverInfo.vechileType,
                vehicle_no: driverInfo.vechileNumber,
                longitude: formData.longitude,
                latitude: formData.latitude,
                location: driverInfo.address_line1 || mapAddress || '',
                // 🔹 Commission payload (Laravel backend will handle calculation)
  // 🔹 Commission payload (3-column model)
commission_type: commissionType || null,
commission: commission,
base_price: basePrice,


                 // 🔹 Commission payload (Laravel backend will handle calculation)
 // 🔹 Commission payload (Laravel backend will handle calculation)


            };

            if (id) {
                // Update existing driver info (without image)
                const result = await driverService.updateDriver(id, payload);
                if (result.success) {
                    // Only upload profile image if user selected a new one
                    if (profileImage) {
                        const imgRes = await driverService.updateProfileImage(id, profileImage);
                        setLoading(false);
                        if (imgRes.success) {
                            toast.success(result.message || 'Driver updated successfully');
                            navigate('/driver');
                        } else {
                            toast.error(imgRes.message || 'Failed to update profile image');
                        }
                    } else {
                        setLoading(false);
                        toast.success(result.message || 'Driver updated successfully');
                        navigate('/driver');
                    }
                } else {
                    setLoading(false);
                    console.log('Result object:', result);
                    console.log('Result errors:', result.errors);
                    if (result.errors) {
                        const allErrors = Object.values(result.errors).flat().join(', ');
                        toast.error(allErrors || result.message || 'Operation failed');
                    } else {
                        toast.error(result.message || 'Operation failed');
                    }
                }
            } else {
                // Add new driver (image included in FormData)
                let formData;
                if (profileImage) {
                    formData = new FormData();
                    Object.entries(payload).forEach(([key, value]) => {
                        formData.append(key, value);
                    });
                    formData.append('profile_image', profileImage);
                }
                const result = await driverService.addDriver(profileImage ? formData : payload);
                setLoading(false);
                if (result.success) {
                    toast.success(result.message || 'Driver created successfully');
                    navigate('/driver');
                } else {
                    console.log('Result object:', result);
                    console.log('Result errors:', result.errors);
                    if (result.errors) {
                        const allErrors = Object.values(result.errors).flat().join(', ');
                        toast.error(allErrors || result.message || 'Operation failed');
                    } else {
                        toast.error(result.message || 'Operation failed');
                    }
                }
            }
        } catch (error) {
            setLoading(false);
            toast.error('Failed to save driver: ' + (error.message || 'Unknown error'));
        }
    };

    const isEdit = !!id;

    if (fetchingDriver) {
        return (
            <div className="container-fluid">
                <div className="row">
                    <div className="col-12">
                        <div className="card">
                            <div className="card-body text-center">
                                <div className="spinner-border" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                                <p className="mt-2">Loading driver data...</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    return (
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="mb-4">
                        <h2 className="fw-bold">{isEdit ? 'Edit Driver' : 'Add New Driver'}</h2>
                    </div>
                    
                    <form className="theme-form theme-form-2 mega-form" onSubmit={handleSubmit}>
                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Name <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    name="firstName"
                                    value={driverInfo.firstName}
                                    onChange={handleInfoChange}
                                    onBlur={() => setTouched(prev => ({ ...prev, firstName: true }))}
                                    required
                                />
                                {touched.firstName && errors.firstName && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.firstName}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Email Address <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <input
                                    className="form-control"
                                    type="email"
                                    name="email"
                                    value={driverInfo.email}
                                    onChange={handleInfoChange}
                                    onBlur={() => setTouched(prev => ({ ...prev, email: true }))}
                                    required
                                />
                                {touched.email && errors.email && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.email}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Phone Number <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <PhoneInput
                                    country={'us'}
                                    value={driverInfo.phoneNumber}
                                    onChange={handlePhoneChange}
                                    inputProps={{
                                        name: 'phoneNumber',
                                        required: true,
                                        className: 'form-control',
                                        onBlur: () => setTouched(prev => ({ ...prev, phoneNumber: true })),
                                    }}
                                    containerStyle={{ width: '100%' }}
                                    inputStyle={{ width: '100%', height: 45, fontSize: '1rem' }}
                                    dropdownStyle={{ zIndex: 9999 }}
                                />
                                {touched.phoneNumber && errors.phoneNumber && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.phoneNumber}
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Vehicle Type <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <select
                                    className="form-control"
                                    name="vechileType"
                                    value={driverInfo.vechileType}
                                    onChange={handleInfoChange}
                                    onBlur={() => setTouched(prev => ({ ...prev, vechileType: true }))}
                                    required
                                >
                                    <option value="">Select Vehicle Type</option>
                                    <option value="Bicycle">Bicycle</option>
                                    <option value="Motorcycle">Motorcycle</option>
                                    <option value="Car">Car</option>
                                    <option value="Van">Van</option>
                                </select>
                                {touched.vechileType && errors.vechileType && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.vechileType}
                                    </div>
                                )}
                            </div>
                        </div>


                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Vehicle Number <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <input
                                    className="form-control"
                                    type="text"
                                    name="vechileNumber"
                                    value={driverInfo.vechileNumber}
                                    onChange={handleInfoChange}
                                    onBlur={() => setTouched(prev => ({ ...prev, vechileNumber: true }))}
                                    required
                                />
                                {touched.vechileNumber && errors.vechileNumber && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.vechileNumber}
                                    </div>
                                )}
                            </div>
                        </div>
                                                {/* 🔹 Commission Type */}
{/* 🔹 Commission Type */}
                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Commission Type <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <select
                                    className="form-control"
                                    name="commissionType"
                                    value={driverInfo.commissionType}
                                    onChange={handleInfoChange}
                                    onBlur={() => setTouched((prev) => ({ ...prev, commissionType: true }))}
                                >
                                    <option value="">Select commission type</option>
                                    <option value="fixed">Fixed</option>
                                    <option value="kmperamount">KM per Commission</option>
                                    <option value="percentage">Commission Percentage %</option>
                                </select>
                                {touched.commissionType && errors.commissionType && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        {errors.commissionType}
                                    </div>
                                )}
                            </div>
                        </div>

{/* 🔹 Fixed → single amount field */}
                        {driverInfo.commissionType === 'fixed' && (
                            <div className="mb-4 row align-items-center">
                                <label className="form-label-title col-sm-3 mb-0">
                                    Fixed Amount
                                </label>
                                <div className="col-sm-9">
                                <div className="input-group">
 <div className="input-group">
  <span className="input-group-text">{currencySymbol}</span>
  <input
    className="form-control"
    type="number"
    min="0"
    step="0.01"
    name="commission"
    value={driverInfo.commission}
    onChange={handleInfoChange}
    onBlur={() => setTouched((prev) => ({ ...prev, commission: true }))}
  />
</div>

</div>

                                    {touched.commission && errors.commission && (
                                        <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                            {errors.commission}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}

{/* 🔹 KM per amount → amount + base price */}
                        {driverInfo.commissionType === 'kmperamount' && (
                            <>
                                <div className="mb-4 row align-items-center">
                                    <label className="form-label-title col-sm-3 mb-0">
                                        Commission (per KM)
                                    </label>
                                    <div className="col-sm-9">
                                       <div className="input-group">
 <div className="input-group">
 <div className="input-group">
  
  <input
    className="form-control"
    type="number"
    min="0"
    step="0.01"
    name="commission"
    value={driverInfo.commission}
    onChange={handleInfoChange}
    onBlur={() => setTouched((prev) => ({ ...prev, commission: true }))}
  />
</div>

</div>

</div>

                                        {touched.commission && errors.commission && (
                                            <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                                {errors.commission}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div className="mb-4 row align-items-center">
                                    <label className="form-label-title col-sm-3 mb-0">
                                        Base Price
                                    </label>
                                    <div className="col-sm-9">
                                      <div className="input-group">
  <span className="input-group-text">{currencySymbol}</span>
  <input
    className="form-control"
    type="number"
    min="0"
    step="0.01"
    name="basePrice"
    value={driverInfo.basePrice}
    onChange={handleInfoChange}
    onBlur={() => setTouched((prev) => ({ ...prev, basePrice: true }))}
  />
</div>

                                        {touched.basePrice && errors.basePrice && (
                                            <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                                {errors.basePrice}
                                            </div>
                                        )}
                                    </div>
                                </div>
                            </>
                        )}

{/* 🔹 Percentage → commission = % */}
                        {driverInfo.commissionType === 'percentage' && (
                            <div className="mb-4 row align-items-center">
                                <label className="form-label-title col-sm-3 mb-0">
                                    Commission Percentage (%)
                                </label>
                                <div className="col-sm-9">
                                    <input
                                        className="form-control"
                                        type="number"
                                        min="1"
                                        max="100"
                                        step="0.01"
                                        name="commission"
                                        value={driverInfo.commission}
                                        onChange={handleInfoChange}
                                        onBlur={() => setTouched((prev) => ({ ...prev, commission: true }))}
                                    />
                                    {touched.commission && errors.commission && (
                                        <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                            {errors.commission}
                                        </div>
                                    )}
                                </div>
                            </div>
                        )}


                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Profile Image <span className="text-danger">*</span>
                            </label>
                            <div className="col-sm-9">
                                <input
                                    className="form-control"
                                    type="file"
                                    accept="image/*"
                                    onChange={handleProfileImageChange}
                                    required={!isEdit}
                                />
                                {profileImagePreview && (
                                    <SafeImage
                                        src={profileImagePreview}
                                        alt="Profile Preview"
                                        style={{ width: 80, height: 80, objectFit: 'cover', marginTop: 8, borderRadius: 8 }}
                                    />
                                )}
                                {!isEdit && !profileImage && touched.profile_image && (
                                    <div style={{ color: '#dc3545', fontSize: '0.875rem', marginTop: '4px' }}>
                                        Profile image is required
                                    </div>
                                )}
                            </div>
                        </div>

                        <div className="mb-4 row align-items-center">
                            <label className="form-label-title col-sm-3 mb-0">
                                Business Location
                            </label>
                            <div className="col-sm-9">
                                <div
                                    className={`form-control text-start${touched.location && errors.location ? ' is-invalid' : ''}`}
                                    style={{
                                        backgroundColor: 'white',
                                        cursor: loading ? 'not-allowed' : 'pointer',
                                        minHeight: '45px',
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '0 12px'
                                    }}
                                    tabIndex={0}
                                    onClick={handleOpenLocationModal}
                                    role="button"
                                    aria-disabled={loading}
                                >
                                    <i className="fa fa-map-marker-alt text-primary me-2"></i>
                                    <span
                                        className={formData.longitude && formData.latitude ? 'text-dark small' : 'text-muted small'}
                                        style={{ fontWeight: 400 }}
                                    >
                                        {formData.longitude && formData.latitude
                                            ? (driverInfo.address_line1 || mapAddress || 'Location Selected')
                                            : 'Click to select your business location'}
                                    </span>
                                </div>
                                {touched.location && errors.location && (
                                    <div className="invalid-feedback d-block">{errors.location}</div>
                                )}
                            </div>
                        </div>

                        <div className="mt-5 mb-4">
                            <button 
                                className="btn btn-animation" 
                                type="submit" 
                                disabled={loading || Object.values(errors).length > 0}
                                style={{
                                    backgroundColor: (loading || Object.values(errors).length > 0) ? '#6c757d' : '',
                                    color: (loading || Object.values(errors).length > 0) ? '#ffffff' : '',
                                    cursor: (loading || Object.values(errors).length > 0) ? 'not-allowed' : 'pointer',
                                    opacity: (loading || Object.values(errors).length > 0) ? 0.6 : 1
                                }}
                            >
                                {loading ? 'Saving...' : (isEdit ? 'Update' : 'Submit')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>

            {/* Location Modal - Clean Bootstrap Design */}
            {showLocationModal && isLoaded && (
              <>
                <div className="modal-backdrop fade show" onClick={() => setShowLocationModal(false)}></div>
                <div className="modal fade show d-block" tabIndex="-1" role="dialog" aria-labelledby="locationModalLabel" aria-modal="true" style={{ background: 'rgba(0,0,0,0.1)' }}>
                  <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                      <div className="modal-header">
                        <div>
                          <h5 className="modal-title" id="locationModalLabel">Choose your Business Location</h5>
                          <h6 className="mb-0 text-muted">{country}</h6>
                          <p className="mt-1 text-muted mb-0" style={{ fontSize: '0.95rem' }}>
                            Enter your address and we will specify the offer for your area.
                          </p>
                        </div>
                        <button type="button" className="btn-close" aria-label="Close" onClick={() => setShowLocationModal(false)}></button>
                      </div>
                      <div className="modal-body">
                        <div className="mb-3">
                          <div className="input-group">
                            <span className="input-group-text bg-white border-end-0" style={{ paddingRight: 0 }}>
                              <i className="fa fa-search text-muted"></i>
                            </span>
                            {isLoaded && (
                              <Autocomplete onLoad={ref => (autocompleteRef.current = ref)} onPlaceChanged={onPlaceChanged}>
                                <input
                                  type="text"
                                  placeholder="Search address"
                                  className="form-control border-start-0"
                                  style={{ maxWidth: 300 }}
                                  value={mapAddress}
                                  onChange={e => setAddress(e.target.value)}
                                />
                              </Autocomplete>
                            )}
                            <button
                              onClick={handleLocationSelect}
                              className="btn btn-primary ms-2 d-flex align-items-center gap-2"
                              disabled={!mapCenter}
                              type="button"
                            >
                              <i className="fas fa-map-marker-alt"></i>
                              Set Location
                            </button>
                            {locationLoading && (
                              <div style={{ textAlign: 'center', margin: '1rem 0' }}>
                                <div className="spinner-border" role="status" />
                                <div>Fetching your current location...</div>
                              </div>
                            )}
                            <button
                              type="button"
                              className="btn ms-2 d-flex align-items-center gap-2"
                              onClick={handleGetCurrentLocation}
                              disabled={locationLoading}
                              style={{ minWidth: 140 }}
                            >
                              <i className="fa fa-location-arrow me-1" style={{ opacity: 0.7 }}></i>
                              {locationLoading ? 'Locating...' : 'Get Current Location'}
                            </button>
                          </div>
                        </div>
                        {mapAddress && (
                          <div className="mb-2">
                            <p className="mb-0"><strong>Address:</strong> {mapAddress}</p>
                          </div>
                        )}
                        {mapError && <p className="text-danger small mb-2">{mapError}</p>}
                        <div className="mb-2">
                          <div style={{ position: 'relative', width: '100%', height: 300 }}>
                            <GoogleMap
                              mapContainerStyle={containerStyle}
                              center={mapCenter}
                              zoom={latLng ? 15 : 6}
                              onLoad={map => (mapRef.current = map)}
                              onDragEnd={() => {
                                if (mapRef.current) {
                                  const newCenter = mapRef.current.getCenter();
                                  setMapCenter({ lat: newCenter.lat(), lng: newCenter.lng() });
                                }
                              }}
                            />
                            <div
                              style={{
                                position: 'absolute',
                                left: '50%',
                                top: '50%',
                                transform: 'translate(-50%, -100%)',
                                pointerEvents: 'none',
                                zIndex: 2
                              }}
                            >
                              <i className="fas fa-map-marker-alt" style={{ fontSize: 36, color: '#d00' }} />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="modal-footer">
                        <button type="button" className="btn btn-secondary" onClick={() => setShowLocationModal(false)}>
                          Cancel
                        </button>
                        <button type="button" className="btn btn-primary" onClick={handleLocationSelect} disabled={!mapCenter}>
                          Save Location
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            )}
        </div>
    )
}

export default AddorUpdate;